// @flow

import stores from 'stores';

export default (imageUrl: string) => {
  return stores.promotionsStore.removeCorruptedImage(imageUrl);
};
